import { IAcademyLessonStepConfig, TAcademyLessonsStepType } from "./academy.t";

export const ACADEMY_LESSON_TYPES = {
    ANIMATION: 'animation',
    DIALOGUE: 'dialogue',
    VIDEO: 'video',
} as const;

export const ACADEMY_COURSE_STATUSES = {
    AVAILABLE: 'available',
    COMPLETED: 'completed',
    IN_PROGRESS: 'in_progress',
} as const;

export const ACADEMY_LESSON_STATUSES = {
    AVAILABLE: 'available',
    COMPLETED: 'completed',
    IN_PROGRESS: 'in_progress',
    LOCKED: 'locked',
} as const;

export const ACADEMY_URL_SEARCH_PARAMS = {
    COURSE_KEY: 'course-key',
    LESSON_KEY: 'lesson-key',
} as const;

export const ACADEMY_LESSONS_STEPS_TYPES = {
    ANIMATION: 'animation',
    DIALOGUE_TEXT: 'dialogue_text',
    DIALOGUE_ARTICLE: 'dialogue_article',
    DIALOGUE_QUESTION_TEXT: 'dialogue_question_text',
    DIALOGUE_QUESTION_ANSWER: 'dialogue_question_answer',
    DIALOGUE_USER_TEXT: 'dialogue_user_text',
} as const;

export const ACADEMY_LESSONS_STEPS_CONFIGS: { [key in TAcademyLessonsStepType]: IAcademyLessonStepConfig } = {
    [ACADEMY_LESSONS_STEPS_TYPES.ANIMATION]: {},
    [ACADEMY_LESSONS_STEPS_TYPES.DIALOGUE_ARTICLE]: {
        isDisabledScrollLessonToBottom: true,
    },
    [ACADEMY_LESSONS_STEPS_TYPES.DIALOGUE_TEXT]: {
        isGuruStep: true,
    },
    [ACADEMY_LESSONS_STEPS_TYPES.DIALOGUE_QUESTION_ANSWER]: {
        isProgressShouldUpdate: true
    },
    [ACADEMY_LESSONS_STEPS_TYPES.DIALOGUE_QUESTION_TEXT]: {
        isGuruStep: true,
        isShowInFooter: true,
    },
    [ACADEMY_LESSONS_STEPS_TYPES.DIALOGUE_USER_TEXT]: {
        isProgressShouldUpdate: true,
        isShowInFooter: true,
    },
} as const;

export const ACADEMY_LESSONS_COURSES = {
    BEGINNERS_GUIDE: 'beginners_guide',
} as const;

export const ACADEMY_LESSONS_KEYS = {
    ONBOARDING: 'onboarding',
} as const;
